/* Extracted from layout/theme.liquid inline <script> blocks so they can load with defer instead of blocking render.
   Two features:
     1) Header mobile-sticky toggle on scroll
     2) Klarna/Cart add-to-cart tracker (Klaviyo _learnq) — self-gates so it only wires up when an add-to-cart form is present on the page
   Splide loader stays inline in theme.liquid on purpose (previous deferral broke the hero carousel). */

(function () {
  /* ------------------------------------------------------------------
     Header sticky on scroll — toggles mm-header-mobile-sticky class
     ------------------------------------------------------------------ */
  var header = document.querySelector('#shopify-section-header');
  if (header) {
    var ticking = false;

    function updateHeader(scrollPosition) {
      if (scrollPosition > 1) {
        header.classList.remove('mm-header-transparent');
        header.classList.add('mm-header-mobile-sticky');
      } else {
        header.classList.add('mm-header-transparent');
        header.classList.remove('mm-header-mobile-sticky');
      }
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          updateHeader(window.scrollY);
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    /* Set initial state matching current scroll (in case the page loads mid-scroll) */
    updateHeader(window.scrollY);
  }
})();

(function () {
  /* ------------------------------------------------------------------
     Klaviyo Added-to-Cart tracker — patches window.fetch to detect
     /cart/add.js POSTs and forwards the item to _learnq.
     Only wires up when the page has an add-to-cart form (roughly
     equivalent to the previous {% if product %} gate, but broader —
     also fires on collection quick-add, cross-sell etc.).
     ------------------------------------------------------------------ */
  function init() {
    if (!document.querySelector("form[action*='/cart/add']")) return;

    var _learnq = window._learnq = window._learnq || [];
    var klAjax = true;

    function addedToCart() {
      fetch(window.location.origin + '/cart.js')
        .then(function (res) {
          return res.clone().json().then(function (data) {
            var cart = {
              total_price: data.total_price / 100,
              $value: data.total_price / 100,
              total_discount: data.total_discount,
              original_total_price: data.original_total_price / 100,
              items: data.items
            };
            if (typeof item !== 'undefined') {
              cart = Object.assign(cart, item);
            }
            if (klAjax) {
              _learnq.push(['track', 'Added to Cart', cart]);
              klAjax = false;
            }
          });
        });
    }

    /* Patch fetch to catch programmatic /cart/add.js requests */
    (function (ns, origFetch) {
      ns.fetch = function () {
        var response = origFetch.apply(this, arguments);
        response.then(function (res) {
          if ((window.location.origin + '/cart/add.js').includes(res.url) && res.url !== '') {
            addedToCart();
          }
        });
        return response;
      };
    }(window, window.fetch));

    /* Also listen on native form submit buttons for legacy ATC forms */
    var atcButtons = document.querySelectorAll("form[action*='/cart/add'] button[type='submit']");
    for (var i = 0; i < atcButtons.length; i++) {
      atcButtons[i].addEventListener('click', function () {
        if (klAjax) {
          _learnq.push(['track', 'Added to Cart', typeof item !== 'undefined' ? item : {}]);
          klAjax = false;
        }
      });
    }
  }

  if (document.readyState === 'complete') {
    init();
  } else {
    window.addEventListener('load', init);
  }
})();
